import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from 'auth/services/auth.service';

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})

export class NavbarComponent {

  constructor(private router: Router, private authService: AuthService) { }

  public get isLoggedIn(): boolean {
    return this.authService.isLoggedIn;
  }

  private logout(): void {
    this.authService.logout()
      .subscribe((response) => {
        this.router.navigateByUrl('/login');
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/navbar/navbar.component.ts